import { EnhancedStore } from '@reduxjs/toolkit';
import { AppState } from './types';

// Do not export it directly, it is encapsulated here.
// It is a practical way to inject use the current store
// contexts where it is not present.
let currentStore: EnhancedStore<AppState> | undefined;

export function withCurrentStore<T = unknown>(
  func: (store: EnhancedStore<AppState>) => T,
) {
  if (!currentStore) {
    throw new Error(`withCurrentStore: store is not present.\n`);
  }

  return func(currentStore);
}

export function updateCurrentStore(store: EnhancedStore<AppState>) {
  currentStore = store;
}
